// assets
import AlertOutlined from '@ant-design/icons/AlertOutlined';
import EnvironmentOutlined from '@ant-design/icons/EnvironmentOutlined';
import ExperimentOutlined from '@ant-design/icons/ExperimentOutlined';
import GroupOutlined from '@ant-design/icons/GroupOutlined';
import InboxOutlined from '@ant-design/icons/InboxOutlined';
import ShopOutlined from '@ant-design/icons/ShopOutlined';

// icons
const icons = {
  AlertOutlined,
  EnvironmentOutlined,
  ExperimentOutlined,
  GroupOutlined,
  InboxOutlined,
  ShopOutlined
};

// ==============================|| MENU ITEMS - BATCHES ||============================== //

const batches = {
  id: 'group-batches',
  title: 'Farm',
  type: 'group',
  children: [
    {
      id: 'batches',
      title: 'Livestock Batches',
      type: 'item',
      url: '/batches',
      icon: icons.GroupOutlined,
      breadcrumbs: false
    },
    {
      id: 'locations',
      title: 'Locations',
      type: 'item',
      url: '/locations',
      icon: icons.EnvironmentOutlined,
      breadcrumbs: false
    },
    {
      id: 'hatchery',
      title: 'Hatchery',
      type: 'item',
      url: '/hatchery',
      icon: icons.ExperimentOutlined,
      breadcrumbs: false
    },
    {
      id: 'input-stock',
      title: 'Input Stock',
      type: 'item',
      url: '/input-stock',
      icon: icons.InboxOutlined,
      breadcrumbs: false
    },
    {
      id: 'suppliers',
      title: 'Suppliers',
      type: 'item',
      url: '/suppliers',
      icon: icons.ShopOutlined,
      breadcrumbs: false
    },
    {
      id: 'alerts',
      title: 'Alerts',
      type: 'item',
      url: '/alerts',
      icon: icons.AlertOutlined,
      breadcrumbs: false
    }
  ]
};

export default batches;
